import "./App.css";
import AboutUs from './Components/AboutUs/AboutUs';
import Cards from './Components/Cards/Cards';
import SectionB from "./Components/SectionB/SectionB.jsx";
import SectionD from "./Components/SectionD/SectionD.jsx";
import Home from "./Components/Home/Home.jsx";
import BackToTop from "./Components/BackToTop/BackToTop.jsx";

function App() {
  return (
    <>
    <Home />
    <Cards />
    <AboutUs />
    <SectionB />
    <SectionD />
    <BackToTop />
    </>
  );
}

export default App;
